import "./ab-button.scss";

const Button = ({ type, onClick, href, target }) => {
  if (href) {
    return (
      <a
        className={`ab-button${type ? ` ${type}` : ""}`}
        href={href}
        target={target}
        onClick={onClick}
      ></a>
    );
  }
  return (
    <button
      className={`ab-button${type ? ` ${type}` : ""}`}
      onClick={onClick}
    ></button>
  );
};

export default Button;
